import React from 'react';

export const getProp = (object, path, value = null) => {
    const pathArray = Array.isArray(path)
        ? path
        : path.split('.').filter((key) => key);

    const pathArrayFlat = pathArray.flatMap((part) =>
        typeof part === 'string' ? part.split('.') : part
    );

    return pathArrayFlat.reduce((obj, key) => obj && obj[key], object) || value;
};

export const getSegments = (regex, str) => {
    const segments = [];
    let lastIndex = 0;
    let match;

    const firstNewLineIndex = str.indexOf('\n');

    if (firstNewLineIndex !== -1) {
        segments.push(str.slice(0, firstNewLineIndex + 1));
        lastIndex = firstNewLineIndex + 1;
    } else {
        segments.push(str);
        return segments;
    }
    // eslint-disable-next-line no-param-reassign
    regex.lastIndex = lastIndex; // Start searching from the position after the first \n
    // eslint-disable-next-line no-cond-assign
    while ((match = regex.exec(str))) {
        if (match.index > lastIndex) {
            segments.push(str.slice(lastIndex, match.index));
        }
        segments.push(match[0]);
        lastIndex = match.index + match[0].length;
    }

    if (lastIndex < str.length) {
        segments.push(str.slice(lastIndex));
    }

    return segments;
};

export const titleRegex = /^.*?[.!?\n\r](?:\s|$)/gs;
const trimRegex = /^[\t ]+|[\t ]+$/gm;

export const parsePost = (postText = '') => {
    const tempText = postText.replace('\n', '\n ');
    const [title, body] = getSegments(titleRegex, tempText);

    // user submitted an empty string - should fail validation
    if (!title && !body) return { title: null, body: null };

    // if post consists of 1 sentence, set body to empty string
    if (!body) {
        return {
            title: title.replace(trimRegex, ''),
            body: '',
        };
    }

    return {
        title: title.replace(/\n+\s+$/, ''),
        body: body.replace(trimRegex, ''),
    };
};

export const autoformatOpts = {
    link: {
        trigger: /([\s]|\.[a-z]{3,})/,
        find: /https?:\/\/[\S]+|(www\.[\S]+)/gi,
        transform: (value, noProtocol) =>
            noProtocol ? `https://${value}` : value,
        format: 'link',
    },
    hashtag: {
        trigger: /[\s]/,
        find: /(?:^|)#[^\s.,;:!?]+/i,
        transform: (value) => value,
        format: 'hashtag',
    },
};

export const linkify = (str) => {
    let match;
    const RE_URL = /\w+:\/\/\S+/g;
    const results = [];
    let lastIndex = 0;
    // eslint-disable-next-line no-cond-assign
    while ((match = RE_URL.exec(str))) {
        const link = match[0];
        if (lastIndex !== match.index) {
            const text = str.substring(lastIndex, match.index);
            results.push(<span key={results.length}>{text}</span>);
        }
        results.push(
            // eslint-disable-next-line react/jsx-no-target-blank
            <a key={results.length} href={link} target="_blank">
                {link}
            </a>
        );
        lastIndex = match.index + link.length;
    }
    if (results.length === 0) {
        return str;
    }
    if (lastIndex !== str.length) {
        results.push(
            <span key={results.length}>{str.substring(lastIndex)}</span>
        );
    }
    return results;
};
